import React from 'react';
import {RouterProvider} from 'react-router-dom';
import {router} from '@app/Router';
import GlobalStyle from "@shared/styles/global-style";

function App() {
    // useEffect(() => {
    //     console.log("🔍 앱 시작 시 localStorage 확인:");
    //     console.log("accessToken:", localStorage.getItem("Authorization"));
    //     console.log("refreshToken:", localStorage.getItem("ReAuthorization"));
    //     console.log("전체 쿠키:", document.cookie);
    //     console.log("------------------------------------------");
    // }, []);

    return (
        <>
            <GlobalStyle/>
            <RouterProvider router={router}/>
        </>
    );
}

export default App;
